/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Optional body for the OAuth start endpoints.
 *
 * The Cometly pixel only runs on the app's register/login pages, so the
 * click token must be read on button click and handed to the backend
 * BEFORE the WorkOS redirect — the callback host can't read it otherwise.
 * It rides a short-lived HttpOnly cookie (like the login state) that the
 * OAuth callback consumes.
 */
export interface OAuthStartRequest {
  comet_token?: string | null;
  fingerprint_event_id?: string | null;
}
